// extracted by mini-css-extract-plugin
export default {"customersTable":"ff80oi7oFd6G4lADGA2Z","searchInput":"N1fqAOFmhl6wWBsFzapS","customerRow":"DHFnPhsBuKGz_E1U0jSt"};